import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { apiCube, AuthorizationCube } from '../../utils/index';

const DashboardQuery = ({ query, render }) => {
  const { cubejsToken } = useSelector(state => state.profile.me);
  const [queryState, setQueryState] = useState({ resultSet: null, isLoading: false});
  const queryKey = JSON.stringify(query);

  const getData = async (query) => {
    setQueryState({ ...queryState, isLoading: true });
    const options = (!AuthorizationCube) ? {headers: {Authorization: cubejsToken}} : {};
    const response = await axios.post(`${apiCube}cubejs-api/v1/load`, { query }, options);
    const resultSet = (response && response.data && response.data.data) ? response.data.data : null;
    setQueryState({ resultSet, isLoading: false });
  };

  useEffect(() => {
    if (query) {
      getData(query);
    }
  }, [queryKey]);

  return render(queryState);
};

export default React.memo(DashboardQuery);
